<template>
<div id="app"   lang="ar" dir="rtl">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
<style>
@import "assets/css/switch.css";
</style>
<style>
@import url('https://cdn.datatables.net/1.10.24/css/jquery.dataTables.min.css');
</style>
<style>
.table thead th {
  text-align: center;
}
.custom-select-sm{
      width: 4.5em;
}
div.dataTables_wrapper {
    direction: rtl;
}
.dataTables_length > label{
  align-items: center;
}
.loader {
    border: 16px solid #f3f3f3; /* Light grey */
    border-top: 16px solid #3c4b64; /* Blue */
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
    top: 20%;
    right: 50%;
    position: absolute;
}
.cover{
    top:0;
    right:0;
    background-color: rgba(255,255,255,0.7);
    position: absolute;
    z-index: +100 !important;
    width: 100%;
    height: 100%;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
.btn-primary {
  color: #fff;
  background-color: #0074d9;
  border-color: #0074d9;
  border-radius: 3px;
}
.btn-warning {
  color: #4f5d73;
  background-color: #f9b115;
  border-color: #f9b115;
  border-radius: 3px;
}
</style>

<style>
@import url("https://fontlibrary.org/face/droid-arabic-kufi");

</style>
